import GoodTimesFontText from '@/TRC/components/goodTimesFontText';

const Header = ({ tabs, activeTab, onTabClick }) => {
	const labelBuilder = (Icon, Label) => {
		return (
			<div className="d-flex align-items-center justify-content-center w-100" style={{ gap: '0.3rem' }}>
				<Icon style={{ fontSize: '1.8rem' }} />
				{Label}
			</div>
		);
	};
	return (
		<div className="header-container">
			<GoodTimesFontText fontSize="clamp(1.15rem, 1.2vw, 1.6rem)">
				<div className="common-content-header d-flex position-relative">
					{tabs.map((tab, idx) => (
						<button
							key={tab.id}
							onClick={() => onTabClick(tab.id, idx)}
							className={`header-tab nav-link text-uppercase fw-normal ${activeTab === tab.id ? 'active' : ''}`}
							style={{
								fontSize: '1.8rem',
								position: 'relative',
								border: 'none',
								background: 'transparent',
							}}
						>
							<span className="tab-name">{labelBuilder(tab.icon, tab.label)}</span>
							{/* Tab underline */}
							<span
								className="tab-underline"
								style={{
									position: 'absolute',
									bottom: '-0.5rem',
									left: 0,
									right: 0,
									height: '0.125rem',
									backgroundColor: activeTab === tab.id ? '#51CBFC' : '#C4C4C4'
								}}
							/>
						</button>
					))}

					{/* Global underline */}
					<span
						className="header-underline"
						style={{
							position: 'absolute',
							bottom: '-0.5rem',
							left: 0,
							width: '100%',
							height: '0.125rem',
							backgroundColor: '#C4C4C4',
							zIndex: -1
						}}
					/>
				</div>
			</GoodTimesFontText>
		</div>
	);
};

export default Header;
